import { CheckGreenIcon } from '../../icons/CheckGreen';
import { memo } from 'react';
import classes from 'classnames';
import styles from './ChecklistItem.module.scss';
import Text from '../Typography/Text';

export type ChecklistItemProps = {
  className?: string;
  text: string;
};

export const ChecklistItem: React.FC<ChecklistItemProps> = memo(
  ({ className, text }) => {
    return (
      <div className={classes(styles.container, className)}>
        <div className={styles.icon}>
          <CheckGreenIcon />
        </div>
        <Text dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    );
  },
);
